import { apiDietAddons } from './apiAddons'
import { apiAddonCategories } from './apiAddonCategories'
import { apiAddonsAsMeals } from './apiAddonsAsMeals'
import { apiAllergens } from './apiAllergens'
import { apiDiet } from './apiDiet'
import { apiDietComponents } from './apiDietComponents'
import { apiDietDays } from './apiDietDays'
import { apiDietaryMedia } from './apiDietaryMedia'
import { apiFoodProductionStage } from './apiFoodProductionStage'
import { apiMaterials } from './apiMaterials'
import { apiMealPackaging } from './apiMealPackaging'
import { apiMeals } from './apiMeals'
import { apiMealSizes } from './apiMealSize'
import { apiMealVariant } from './apiMealVariant'
import { apiMesErrorReports } from './apiMesErrorReports'
import { apiNutritionalParameters } from './apiNutritionalParameters'
import { apiProductionPlanMeals } from './apiProductionPlanMeals'
import { apiProductionStage } from './apiProductionStage'
import { apiSemiProducts } from './apiSemiProducts'
import { apiSizeMatrices } from './apiSizeMatrices'
import { apiDietTags } from './apiTags'

const apiDietary = {
	...apiDiet,
	...apiDietaryMedia,
	...apiMaterials,
	...apiAllergens,
	...apiSemiProducts,
	...apiMeals,
	...apiFoodProductionStage,
	...apiProductionStage,
	...apiDietComponents,
	...apiMealPackaging,
	...apiNutritionalParameters,
	...apiMealSizes,
	...apiMealVariant,
	...apiDietTags,
	...apiDietDays,
	...apiDietAddons,
	...apiAddonCategories,
	...apiSizeMatrices,
	...apiAddonsAsMeals,
	...apiProductionPlanMeals,
	...apiMesErrorReports,
}

export { apiDietary }
